// Allowed upload formats are owned by platform-api's
// UnstructuredUploadSettings.ALLOWED_MIME_TYPES; this is the narrower subset we
// can render inline. Office formats need a converter or a heavy client-side
// renderer, so they are PDF-only for now.
export const PREVIEWABLE_MIME_TYPES: readonly string[] = ['application/pdf'];

export const isPreviewableMimeType = (
  contentType: string | null | undefined,
): boolean => {
  if (!contentType) return false;
  const normalized = contentType.split(';')[0].trim().toLowerCase();
  return PREVIEWABLE_MIME_TYPES.includes(normalized);
};
